<template>
    <div id="nav-menu" class="tw-bg-white">
        <div class="nav-menu-inner tw-flex tw-flex-col tw-fixed">
            <div class="tw-flex-1" v-bar>
                <div class="tw-flex tw-flex-col">
                    <div class="tw-flex tw-flex-col tw-px-3 tw-pt-10">
                        <nav-boards></nav-boards>
                        <nav-moodboards></nav-moodboards>
                        <nav-groups v-if="plugins.groups && hasPlan(8)"></nav-groups>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../../mixins/Global';
	import Plans from '../../../mixins/v2/Plans.js';

    import NavBoards from './NavBoards.vue';
    import NavGroups from './NavGroups.vue';
    import NavMoodboards from './NavMoodboards.vue';

    export default {
        name: 'NavBar',

        mixins: [ Global, Plans ],

        components: {
            'nav-boards': NavBoards,
            'nav-groups': NavGroups,
            'nav-moodboards': NavMoodboards,
        },
    };
</script>

<style lang="scss">
    #nav-menu {
        width: 250px;
        box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.03);
        z-index: 12;

        .nav-menu-inner {
            width: 250px;
            top: 70px;
            height: calc(100vh - 70px);

            .vb-content {
                @apply tw-flex #{!important};
            }

            .nav-section {
                @apply tw-mb-6;

                .nav-section-title {
                    @apply tw-flex tw-items-center tw-text-lg tw-mb-2 tw-ml-3;

                    i {
                        @apply tw-mr-2 tw-pt-px;
                    }

                    h3 {
                        @apply tw-font-semibold;
                    }
                }

                .nav-item {
                    @apply tw-flex tw-cursor-pointer tw-rounded;

                    a {
                        @apply tw-flex;

                        .board-navigation-item {
                            @apply tw-flex-1;
                        }

                        .notification-count {
                            @apply tw-relative;
                            margin-top: 3px;
                            margin-left: 5px;
                        }
                    }

                    &:hover {
                        @apply tw-bg-gray-0;
                    }

                    &:active {
                        @apply tw-bg-gray-100;
                    }

                    .mainboard {
                        @apply tw-p-3 tw-w-full;
                    }

                    &.group-item {
                        @apply tw-p-3;
                    }
                }
            }
        }

        @media(max-width: 1100px) {
            .nav-menu-inner {
                height: calc(100vh - 115px);
            }
        }

        @media(max-width: 1023px) {
            @apply tw-hidden;
        }
    }
</style>
